// extracted by mini-css-extract-plugin
export default {"title":"profile_title__b9Brw","password":"profile_password__Ldnm8","passButton":"profile_passButton__4IY8Y","para":"profile_para__y9I3H"};